import { create } from "zustand"

interface SelectedService {
  name: string
  icon_url: string
  setService: (name: string, icon_url: string) => void
  reset: () => void
}

const useSelectedServiceStore = create<SelectedService>()((set) => ({
  name: "",
  icon_url: "",
  setService: (name: string, icon_url: string) => set({ name, icon_url }),
  reset: () =>
    set({
      name: "",
      icon_url: "",
    }),
}))

export { useSelectedServiceStore }
